import { render, staticRenderFns } from "./KnProductTaxes.vue?vue&type=template&id=2acaaad0"
import script from "./KnProductTaxes.js?vue&type=script&lang=js&external"
export * from "./KnProductTaxes.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports